module.exports = __webpack_public_path__ + "static/media/step-indicator-3.70e6ab68.svg";